const DescriptionSection = ({ description, setDescription, name, setName }) => (
  <div className="grid" style={{ gap: "12px" }}>
    <div>
      <label className="field-label">Describe the agent you want</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={4}
        className="code-block code-block--plain"
        placeholder="Describe the agent you want"
      />
    </div>

    <div>
      <label className="field-label">Name</label>
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Internal name"
        className="code-block code-block--plain"
        style={{ minHeight: "auto", height: "48px" }}
      />
    </div>
  </div>
);

export default DescriptionSection;
